import React, { useState } from "react";
import { MdOutlineEmail, MdOutlinePhone, MdArrowForward } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import NavigationBanner from "../../components/common/NavigationBanner";
import HeaderBg from "../../Assets/Images/Bannerimage.png";
import volunteer_icon from "../../Assets/Images/get-involved/work.png";
import supporting_icon from "../../Assets/Images/get-involved/supporting.png";
import partner_icon from "../../Assets/Images/get-involved/partner.png";
import VolunteerFormModal from "../../components/user/Modal/VolunteerFormModal";
import PartnerFormModal from "../../components/user/Modal/PartnerFormModal";
import { contact_details } from "../../Assets/assests";
import { useApp } from "../../context/AppContext"; // ADDED

const GetInvolved = () => {
  return (
    <div>
      <NavigationBanner title={"Get Involved"} background={HeaderBg} />
      <Content />
    </div>
  );
};

export const Content = () => {
  const navigate = useNavigate();
  const [isVolunteerModalOpen, setIsVolunteerModalOpen] = useState(false);
  const [isPartnerModalOpen, setIsPartnerModalOpen] = useState(false);

  const { contact } = useApp(); 

  // FALLBACKS
  const EMAIL = contact?.directorEmail || contact_details.directorEmail;
  const PHONE = contact?.phone || contact_details.mobile;

  // Volunteer Form Modal
  const handleVolunteerClick = () => {
    setIsVolunteerModalOpen(true);
  };

  const handleCloseVolunteerModal = () => {
    setIsVolunteerModalOpen(false);
  };

  // Partner Form Modal
  const handlePartnerClick = () => {
    setIsPartnerModalOpen(true);
  };

  const handleClosePartnerModal = () => {
    setIsPartnerModalOpen(false);
  };

  // Navigate to campaigns
  const handleSupportClick = () => {
    navigate("/campaigns");
  };

  const sections = [
    {
      icon: volunteer_icon,
      title: "Volunteer with us",
      text: `your time can spark hope.`,
      bg: "bg-purple-500/20",
      arrowColor: "text-purple-500",
      arrowBg: "bg-purple-500/10",
      arrowHoverBg: "group-hover:bg-purple-500",
      aos: "fade-up",
      onClick: handleVolunteerClick,
    },
    {
      icon: partner_icon,
      title: "Partner with us",
      text: `let's build stronger communities together.`,
      bg: "bg-green-500/20",
      arrowColor: "text-green-500",
      arrowBg: "bg-green-500/10",
      arrowHoverBg: "group-hover:bg-green-500",
      aos: "fade-down",
      onClick: handlePartnerClick,
    },
    {
      icon: supporting_icon,
      title: "Support our cause",
      text: `every contribution fuels a brighter future.`,
      bg: "bg-blue-500/20",
      arrowColor: "text-blue-500",
      arrowBg: "bg-blue-500/10",
      arrowHoverBg: "group-hover:bg-blue-500",
      aos: "fade-up",
      onClick: handleSupportClick,
    },
  ];

  return (
    <div className="w-full px-4 md:px-[5rem] py-12">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-center tracking-wide pb-12 text-primaryTextColor relative">
          Be a part of the change you wish to see.
        </h2>

        {/* Sections Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {sections.map((item, idx) => (
            <div
              key={idx}
              onClick={item.onClick}
              className="group w-full px-6 py-8 flex flex-col items-center gap-2 rounded-xl bg-white 
                transition-all duration-500 border border-primaryFadedColor/20 transform cursor-pointer relative overflow-hidden
                shadow-md hover:shadow-lg hover:-translate-y-3"
              data-aos={item.aos}
              data-aos-duration="1000"
              data-aos-delay={idx * 200}
            >
              {/* Arrow Icon - Top Right */}
              <div
                className={`absolute top-4 right-4 w-10 h-10 ${item.arrowBg} ${item.arrowHoverBg} rounded-full flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:rotate-45`}
              >
                <MdArrowForward
                  className={`${item.arrowColor} group-hover:text-white text-xl transition-colors duration-300`}
                />
              </div>

              <div
                className={`p-4 size-20 scale-90 relative ${item.bg} rounded-full transition-all duration-500 group-hover:scale-100 group-hover:rotate-6 shadow-lg group-hover:shadow-xl`}
              >
                <img
                  className="size-16 absolute -top-2 -left-4 transition-transform duration-500 group-hover:scale-110 filter drop-shadow-md"
                  src={item.icon}
                  alt="icon"
                />
                <div className="absolute inset-0 rounded-full bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-sm"></div>
              </div>

              <h3 className="text-xl text-center font-semibold text-primaryTextColor group-hover:text-primaryColor transition-colors duration-300 relative z-10">
                {item.title}
              </h3>

              <p className="text-secondaryTextColor group-hover:text-primaryTextColor text-center leading-relaxed transition-colors duration-300 relative z-10">
                {item.text}
              </p>
            </div>
          ))}
        </div>

        {/* CONTACT SECTION */}
        <div
          className="text-center mt-12 bg-white/60 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-gray-100"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <div className="relative">
            <p className="text-gray-700 mb-4 text-lg">
              Interested in joining or collaborating? Reach us at:
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-gray-900 font-medium">
              <a
                href={"mailto:" + EMAIL}
                className="hover:text-purple-600 transition-colors duration-300 flex items-center gap-2 hover:underline"
              >
                <span className="text-purple-500">
                  <MdOutlineEmail />
                </span>
                {EMAIL}
              </a>

              <span className="hidden sm:block text-gray-400">|</span>

              <a
                href={`tel:${PHONE}`}
                className="hover:text-green-600 transition-colors duration-300 flex items-center gap-2 hover:underline"
              >
                <span className="text-green-500">
                  <MdOutlinePhone />
                </span>
                {PHONE}
              </a>
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-4 -left-4 w-8 h-8 bg-purple-500/10 rounded-full animate-pulse"></div>
            <div
              className="absolute -bottom-4 -right-4 w-6 h-6 bg-blue-500/10 rounded-full animate-pulse"
              style={{ animationDelay: "0.5s" }}
            ></div>
          </div>
        </div>
      </div>

      {/* Volunteer Form Modal */}
      <VolunteerFormModal
        isOpen={isVolunteerModalOpen}
        onClose={handleCloseVolunteerModal}
      />

      {/* Partner Form Modal */}
      <PartnerFormModal
        isOpen={isPartnerModalOpen}
        onClose={handleClosePartnerModal}
      />
    </div>
  );
};

export default GetInvolved;

// import React, { useState } from "react";
// import { MdOutlineEmail, MdOutlinePhone, MdArrowForward } from "react-icons/md";
// import { useNavigate } from "react-router-dom";
// import NavigationBanner from "../../components/common/NavigationBanner";
// import HeaderBg from "../../Assets/Images/Bannerimage.png";
// import volunteer_icon from "../../Assets/Images/get-involved/work.png";
// import supporting_icon from "../../Assets/Images/get-involved/supporting.png";
// import partner_icon from "../../Assets/Images/get-involved/partner.png";
// import VolunteerFormModal from "../../components/user/Modal/VolunteerFormModal";
// import PartnerFormModal from "../../components/user/Modal/PartnerFormModal";
// import { contact_details } from "../../Assets/assests";

// const GetInvolved = () => {
//   return (
//     <div>
//       <NavigationBanner title={"Get Involved"} background={HeaderBg} />
//       <Content />
//     </div>
//   );
// };

// export const Content = () => {
//   const navigate = useNavigate();
//   const [isVolunteerModalOpen, setIsVolunteerModalOpen] = useState(false);
//   const [isPartnerModalOpen, setIsPartnerModalOpen] = useState(false);

//   // Volunteer Form Modal
//   const handleVolunteerClick = () => {
//     setIsVolunteerModalOpen(true);
//   };

//   const handleCloseVolunteerModal = () => {
//     setIsVolunteerModalOpen(false);
//   };

//   // Partner Form Modal
//   const handlePartnerClick = () => {
//     setIsPartnerModalOpen(true);
//   };

//   const handleClosePartnerModal = () => {
//     setIsPartnerModalOpen(false);
//   };

//   // Navigate to campaigns
//   const handleSupportClick = () => {
//     navigate("/campaigns");
//   };

//   const sections = [
//     {
//       icon: volunteer_icon,
//       title: "Volunteer with us",
//       text: `your time can spark hope.`,
//       bg: "bg-purple-500/20",
//       arrowColor: "text-purple-500",
//       arrowBg: "bg-purple-500/10",
//       arrowHoverBg: "group-hover:bg-purple-500",
//       aos: "fade-up",
//       onClick: handleVolunteerClick,
//     },
//     {
//       icon: partner_icon,
//       title: "Partner with us",
//       text: `let's build stronger communities together.`,
//       bg: "bg-green-500/20",
//       arrowColor: "text-green-500",
//       arrowBg: "bg-green-500/10",
//       arrowHoverBg: "group-hover:bg-green-500",
//       aos: "fade-down",
//       onClick: handlePartnerClick,
//     },
//     {
//       icon: supporting_icon,
//       title: "Support our cause",
//       text: `every contribution fuels a brighter future.`,
//       bg: "bg-blue-500/20",
//       arrowColor: "text-blue-500",
//       arrowBg: "bg-blue-500/10",
//       arrowHoverBg: "group-hover:bg-blue-500",
//       aos: "fade-up",
//       onClick: handleSupportClick,
//     },
//   ];

//   return (
//     <div className="w-full px-4 md:px-[5rem] py-12">
//       <div className="max-w-6xl mx-auto">
//         <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-center tracking-wide pb-12 text-primaryTextColor relative">
//           Be a part of the change you wish to see.
//         </h2>

//         {/* Sections Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
//           {sections.map((item, idx) => (
//             <div
//               key={idx}
//               onClick={item.onClick}
//               className="group w-full px-6 py-8 flex flex-col items-center gap-2 rounded-xl bg-white
//                 transition-all duration-500 border border-primaryFadedColor/20 transform cursor-pointer relative overflow-hidden
//                 shadow-md hover:shadow-lg hover:-translate-y-3"
//               data-aos={item.aos}
//               data-aos-duration="1000"
//               data-aos-delay={idx * 200}
//             >
//               {/* Arrow Icon - Top Right */}
//               <div
//                 className={`absolute top-4 right-4 w-10 h-10 ${item.arrowBg} ${item.arrowHoverBg} rounded-full flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:rotate-45`}
//               >
//                 <MdArrowForward
//                   className={`${item.arrowColor} group-hover:text-white text-xl transition-colors duration-300`}
//                 />
//               </div>

//               <div
//                 className={`p-4 size-20 scale-90 relative ${item.bg} rounded-full transition-all duration-500 group-hover:scale-100 group-hover:rotate-6 shadow-lg group-hover:shadow-xl`}
//               >
//                 <img
//                   className="size-16 absolute -top-2 -left-4 transition-transform duration-500 group-hover:scale-110 filter drop-shadow-md"
//                   src={item.icon}
//                   alt="icon"
//                 />
//                 {/* Subtle glow effect */}
//                 <div className="absolute inset-0 rounded-full bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-sm"></div>
//               </div>

//               <h3 className="text-xl text-center font-semibold text-primaryTextColor group-hover:text-primaryColor transition-colors duration-300 relative z-10">
//                 {item.title}
//               </h3>

//               <p className="text-secondaryTextColor group-hover:text-primaryTextColor text-center leading-relaxed transition-colors duration-300 relative z-10">
//                 {item.text}
//               </p>
//             </div>
//           ))}
//         </div>

//         {/* Enhanced Contact Section */}
//         <div
//           className="text-center mt-12 bg-white/60 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-gray-100"
//           data-aos="fade-up"
//           data-aos-duration="1000"
//         >
//           <div className="relative">
//             <p className="text-gray-700 mb-4 text-lg">
//               Interested in joining or collaborating? Reach us at:
//             </p>
//             <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-gray-900 font-medium">
//               <a
//                 href={"mailto:" + contact_details.email}
//                 className="hover:text-purple-600 transition-colors duration-300 flex items-center gap-2 hover:underline"
//               >
//                 <span className="text-purple-500">
//                   <MdOutlineEmail />
//                 </span>
//                 {contact_details.email}
//               </a>
//               <span className="hidden sm:block text-gray-400">|</span>
//               <a
//                 href={`tel:${contact_details?.mobile}`}
//                 className="hover:text-green-600 transition-colors duration-300 flex items-center gap-2 hover:underline"
//               >
//                 <span className="text-green-500">
//                   <MdOutlinePhone />
//                 </span>
//                 {contact_details?.mobile}{" "}
//               </a>
//             </div>

//             {/* Decorative elements */}
//             <div className="absolute -top-4 -left-4 w-8 h-8 bg-purple-500/10 rounded-full animate-pulse"></div>
//             <div
//               className="absolute -bottom-4 -right-4 w-6 h-6 bg-blue-500/10 rounded-full animate-pulse"
//               style={{ animationDelay: "0.5s" }}
//             ></div>
//           </div>
//         </div>
//       </div>

//       {/* Volunteer Form Modal */}
//       <VolunteerFormModal
//         isOpen={isVolunteerModalOpen}
//         onClose={handleCloseVolunteerModal}
//       />

//       {/* Partner Form Modal */}
//       <PartnerFormModal
//         isOpen={isPartnerModalOpen}
//         onClose={handleClosePartnerModal}
//       />
//     </div>
//   );
// };

// export default GetInvolved;
